import { WatchLater } from '@material-ui/icons'

export default (props) => <WatchLater htmlColor='#00BCD4' {...props} />
